import { createFileRoute } from '@tanstack/react-router';

import { AdvertisementsPage } from '@/features/banners/AdvertisementsPage';

export const Route = createFileRoute('/admin/_app/advertisement')({
  component: AdvertisementsPage,
});
